import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useSettings } from "@/context/SettingsContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import ProductListing from "@/components/ProductListing";
import Seo from "@/components/Seo";
import SchemaLd from "@/components/SchemaLd";
import { ChevronLeft, Truck } from "lucide-react";

export default function BrandPage() {
  const { brand } = useParams();
  const decoded = decodeURIComponent(brand || "");
  const [seo, setSeo] = useState(null);
  const navigate = useNavigate();
  const settings = useSettings();

  useEffect(() => {
    window.scrollTo(0, 0);
    api.get("/seo/page", { params: { type: "brand", key: decoded } }).then((r) => setSeo(r.data.effective)).catch(() => setSeo(null));
  }, [decoded]);

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Header />
      <Seo title={seo?.seo_title || `${decoded} products`}
        description={seo?.meta_description || `Shop ${decoded} products at ACP Online — New Zealand trade supplier. Trade pricing, fast NZ delivery and GST tax invoices.`}
        image={seo?.og_image || undefined} canonical={seo?.canonical || undefined}
        noindex={seo?.seo_index === "noindex"} />
      <SchemaLd type="brand" ekey={decoded} />
      <section className="bg-steel text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
          <button onClick={() => navigate("/")} data-testid="brand-back" className="flex items-center gap-1 text-sm text-slate-300 hover:text-accent mb-3">
            <ChevronLeft size={16} /> All products
          </button>
          <span className="text-xs font-mono tracking-[0.3em] text-accent">BRAND</span>
          <h1 className="mt-2 text-4xl sm:text-5xl font-extrabold" data-testid="brand-heading">{decoded}</h1>
          <p className="mt-3 text-slate-300 flex items-center gap-2 text-sm">
            <Truck size={15} className="text-accent" /> {settings?.free_shipping_public_message || "FREE NZ shipping on orders $1,000+"}
          </p>
        </div>
      </section>
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 w-full flex-1">
        <ProductListing params={{ brand: decoded }} testid="brand-product"
          empty={<div className="text-center py-20">
            <p className="text-muted-foreground">No products found for {decoded}.</p>
            <button onClick={() => navigate("/")} className="mt-4 text-accent hover:underline">Browse all products →</button>
          </div>} />
      </main>
      <Footer />
    </div>
  );
}
